var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResume(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.193,
    height: 39.294,
    viewBox: "0 0 31.193 39.294",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "resume",
    transform: "translate(-51.944 -3.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2675",
    "data-name": "Group 2675",
    transform: "translate(48.272 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4420",
    "data-name": "Path 4420",
    d: "M158.6,274.636H136.727a.629.629,0,1,0,0,1.259H158.6a.629.629,0,1,0,0-1.259Z",
    transform: "translate(-128.728 -251.589)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4421",
    "data-name": "Path 4421",
    d: "M158.6,322.961H136.727a.629.629,0,1,0,0,1.259H158.6a.629.629,0,1,0,0-1.259Z",
    transform: "translate(-128.728 -295.859)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4422",
    "data-name": "Path 4422",
    d: "M158.6,371.286H136.727a.629.629,0,1,0,0,1.259H158.6a.629.629,0,1,0,0-1.259Z",
    transform: "translate(-128.728 -340.128)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4423",
    "data-name": "Path 4423",
    d: "M158.6,419.611H136.727a.629.629,0,1,0,0,1.259H158.6a.629.629,0,1,0,0-1.259Z",
    transform: "translate(-128.728 -384.398)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4424",
    "data-name": "Path 4424",
    d: "M309.664,175.7h-8.039a.629.629,0,0,0,0,1.259h8.039a.629.629,0,1,0,0-1.259Z",
    transform: "translate(-279.788 -160.957)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4425",
    "data-name": "Path 4425",
    d: "M309.664,136.06h-8.039a.629.629,0,1,0,0,1.259h8.039a.629.629,0,1,0,0-1.259Z",
    transform: "translate(-279.788 -124.642)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4426",
    "data-name": "Path 4426",
    d: "M82.507,35a.629.629,0,0,0,.629-.629V6.147a2.478,2.478,0,0,0-2.475-2.475H78.206c.017.044-26.277,34.349-26.262,34.364v2.456a2.478,2.478,0,0,0,2.475,2.475H80.661a2.478,2.478,0,0,0,2.475-2.475V33.248a.629.629,0,1,0-1.259,0v7.244a1.218,1.218,0,0,1-1.216,1.216H54.419A1.218,1.218,0,0,1,53.2,40.491V6.147a1.218,1.218,0,0,1,1.216-1.216H80.661a1.218,1.218,0,0,1,1.216,1.216V34.371A.629.629,0,0,0,82.507,35ZM51.944,6.147V38.036c0-.017,26.259-34.282,26.262-34.364H54.419a2.478,2.478,0,0,0-2.475,2.475Z",
    transform: "translate(-48.272 0)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4427",
    "data-name": "Path 4427",
    d: "M136.125,96.266a.629.629,0,0,0-.629.629v4.753a1.922,1.922,0,0,0,1.717,1.916c.237.026,7.02,0,7.031,0h.007a1.922,1.922,0,0,0,1.718-1.916V93.44a1.929,1.929,0,0,0-1.927-1.927h-6.62A1.929,1.929,0,0,0,135.5,93.44v.493a.629.629,0,0,0,1.259,0V93.44a.669.669,0,0,1,.668-.668h6.62a.669.669,0,0,1,.668.668v6.443a5.447,5.447,0,0,0-1.7-1.218,2.7,2.7,0,1,0-4.552,0,5.445,5.445,0,0,0-1.7,1.218V96.9A.629.629,0,0,0,136.125,96.266Zm4.607-.482a1.438,1.438,0,1,1-1.437,1.437A1.439,1.439,0,0,1,140.733,95.784ZM139.5,99.615a2.684,2.684,0,0,0,2.474,0A4.2,4.2,0,0,1,144.612,102a.664.664,0,0,1-.5.313c-.041,0-6.653.009-6.748,0h-.015a.664.664,0,0,1-.5-.313A4.2,4.2,0,0,1,139.5,99.615Z",
    transform: "translate(-128.176 -83.833)",
    fill: "#525252"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResume);
export default __webpack_public_path__ + "static/media/resume.459eb93d8f3be57dbf368a20945a140d.svg";
export { ForwardRef as ReactComponent };